export const tenantMemberRefNo = data => {
  try {
    return data.tenantMember.tenantMemberRefNo ? data.tenantMember.tenantMemberRefNo : null;
  } catch (error) {
    return null;
  }
};
